import React, { useState, useMemo, useContext, useEffect } from "react";
import _ from "lodash";
import moment from "moment";
import styled from "styled-components";
import UploadUser from "./UploadUser";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getUsers } from "../../services/ConfigServices";
import axios from "axios";
import { usertypeData } from "variables/lists/users";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import EditUsers from "./EditUsers";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const StyledTextField = styled.input`
    height: 32px;
    width: 200px;
    border: 0px;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: text;
    }
  `;

const ClearButton = styled.button`
    border: 0px solid rgba(0, 0, 0, 0.15);
    border-left: 0px;
    background-color: none;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
  `;

const SearchContainer = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

export default function useEntitesTable(props) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const users_update = permis.includes("users_update");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, chartIdGroup } = appContext;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sorted, setSorted] = useState();
  const [filtered, setFiltered] = useState();
  const [totalRows, setTotalRows] = useState(0);
  //const [idGroup, setIdGroup] = useState(2151);
  const [results, setResults] = useState({});
  const [gridState, setGridState] = useState();
  const [refresh, setRefresh] = useState(false);
  const [permissionList, setPermissionList] = useState([]);
  const [viewList, setViewList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          getUsers(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setPermissionList(response.data.permissions);
        setViewList(response.data.views);
        setLoading(false);

        let userstmp = response.data.users.map((u)=>u.id);
        console.log(userstmp);
        
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);
  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);


  const refreshTable = () => {
    setRefresh(!refresh);
  };

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus={true}
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const filteredItems = _.get(results, "users", []).filter(
    (item) =>
      (item.viewname &&
        item.viewname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.firstname &&
        item.firstname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.email &&
        item.email.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.lastname &&
        item.lastname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = users.map((item) => {
      let usertoexport = {};
      usertoexport["Nom"] = item.lastname + ' ' + item.firstname;
      usertoexport["Login/Email"] = item.email;
      usertoexport["Type"] = usertypeData.find((x) => x.id == item.usertype)?.name || '';
      usertoexport["Vue"] = item.viewname || '';
      usertoexport["Permissions"] = item.permissionname || '';
      usertoexport["Groupes"] = item.usergrouplist?.map((groupid) => {
        return ('\'' + groupInfoListById["" + groupid] + '\'');
      });
      usertoexport["Dernière connexion"] = (item.lastconnection && moment(item.lastconnection).isValid()) ? moment(item.lastconnection).format("DD/MM/YYYY hh:mm") : "";
      return usertoexport;
    });
    return (
      <>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {users_update && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <UploadUser onClick={handleClear} refetch={refreshTable} setLoading={setLoading} setNotification={setNotification} />
            </UploadButton>
            <UploadButton type="button">
              <EditUsers refetch={refreshTable} users={users} permissionlist={permissionList} viewlist={viewList} disabled={!users || users.length < 1} />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!users || users.length < 1} />
        </UploadButton>

      </>
    );
  }, [filterText, resetPaginationToggle, users, permissionList, viewList]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      permissions: _.get(results, "permissions", []),
      views: _.get(results, "views", []),
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading: loading,
    },
    permissionList,
    viewList,
    refreshTable,
    setLoading,
    setUsers,
  };
}
